import { PurchaseOrderStatusEnum } from "@finway-group/shared/lib/models"
import { type QueryParams } from "~Shared/queries/consts"

export const defaultFilterInvoiceLink = { "state.currentState": { in: [PurchaseOrderStatusEnum.FULFILLMENT] } }
export const defaultQueryParamsInvoiceLink: QueryParams = {
    page: 1,
    limit: 5,
    search: "",
}

export const defaultFilterDeliveryNoteLink = { "state.currentState": { in: [PurchaseOrderStatusEnum.FULFILLMENT] }, isService: { nis: true } }
